export default {
  listTarifsState: 'in-progress',
  addCategorieState: 'ok',
  listTarifsRecords: [],
  tarifsState: {},
  updateCount: 0
}
